

// import { SSOAPI } from '@/network/network'
import {Component, Vue} from 'vue-property-decorator'
// import axios from 'axios';
import user_module from '@/modules/user/index';

@Component
export default class PageSSO extends Vue {


  get token(){

    return user_module.token;
  }

  get fingerprint(){

    return user_module.fingerPrint;
  }

  async mounted(){

    let s = this.$route.query.SAMLRequest;

    let SAMLRequest = s ? encodeURIComponent(String(s)) : sessionStorage.getItem('SAMLRequest');

    if (SAMLRequest){

      let AuthRequest = 'Auth/AuthRequest?SAMLRequest=';

      console.log('samlRequest', SAMLRequest, AuthRequest)

      if (this.$route.path === "/sandbox/sso"){

        AuthRequest = 'Auth/SandBox/AuthRequest?SAMLRequest=';

      }

      if (this.token){

        // const example = 'fFHJTsMwFPyVyHc3a5dYTaTSFhGpQNSEHnpBruNQS44d%2fByWvyckIJUDvY5meTNvCbSRLVl19qz2%2fLXjYJ1sk6Bnv45PQcAW%2bFTFIY4ib4rjcM4xo3xWz%2f0oCqsQOQduQGiVoGDiIScD6HimwFJle8gLfOzF2J%2bV3oJMFySKjsjJjbaaaXkjVCXUS4I6o4imIIAo2nAglpFidb8jvSM5jSQgd2WZ4%2fyxKJGzAuDG9qFrraBruCm4eROMP%2b13CTpb2xLXlZpRedZgyTQIQpeNTOR8NFIBGSpfD25%2frkTp8ptNhmbmQn9dTn9vRGm5fThkx0m5Lcqle%2bE1GrfkoRdnm1xLwT6dW20a2k%2f3n7c%2f8QdEVLgeqKRT0HImasGrfhop9fvacGp5gqzp%2bsZuOqb%2bfXH6BQAA%2f%2f8DAA%3d%3d';


        if (SAMLRequest){

          location.href = 'https://rixtrema.net/api/sso/' + AuthRequest + SAMLRequest + '&token=' + this.token + '&fingerprint=' + this.fingerprint;
        }

        // try {


        //   const response: any = await SSOAPI.get(AuthRequest + SAMLRequest)
          
        //   if (response && response.redirectUrl){

        //     const formData = new FormData();

        //     formData.append('SAMLResponse', response.samlResponse)

        //     const response2 = await axios.post(response.redirectUrl, formData);
        //     console.log('response2', response2);

        //       if (response2 && RedirectUrl){
        //         location.href = RedirectUrl;
        //       }
            

        //   }
        // } catch(err){

        //   this.$toasted.error(err, {
        //     duration: 4000
        //   });
        // }


      } else {

        sessionStorage.setItem('SAMLRequest', SAMLRequest)
        console.log('saml!!!', '/login?redirect=' + this.$route.path + '?SAMLRequest=' + SAMLRequest)
        this.$router.push('/login?redirect=' + this.$route.path);
      }

    }

 

  }
}
